export enum Action {
  Create = "CREATE",
  Update = "UPDATE",
}

export interface IFormProviderChildrenData {
  handleError: (error: any) => void;
}

export type FormProps = {
  data: { [key: string]: any };
  fields: FormWrapper[] | FormField[] | FormRowWrapper[];
  onSubmit?: (data: any) => Promise<any>;
  id?: string;
  defaultValues?: any;
  innerRef?: any;
  formErrorFieldName?: string;
  filterOnlyDay?: boolean;
}

export type FormWrapper = {
  type: 'wrapper';
  _children: FormField[];
}

export type FormRowWrapper = {
  type: 'row-wrapper';
  _children: FormField[];
}

export type FileOploadOptions = {
  fileSrc: string;
  contentType?: string;
  acceptType?: string[];
  maxSize?: number;
}

export type SelectOptions = {
  isGrouped?: boolean;
  showGroupHeading?: any;
  optionComponent?: any;
  styles?: any;
}

export type DateInputOptions = {
  fromDateInputName?: string;
  toDateInputName?: string;
  fromHourInputName?: string;
  fromMinuteInputName?: string;
  toHourInputName?: string;
  toMinuteInputName?: string;
  fromDateInputDefaultValue?: string;
  toDateInputDefaultValue?: string;
  fromHourInputDefaultValue?: string;
  fromMinuteInputDefaultValue?: string;
  toHourInputDefaultValue?: string;
  toMinuteInputDefaultValue?: string;
  dateInputPlaceholder?: string;
  hourInputPlaceholder?: string;
  minuteInputPlaceholder?: string;
}

export type dateInputEvents = {
  onDateChange?: (...args: any) => void;
  onHourChange?: (...args: any) => void;
  onMinuteChange?: (...args: any) => void;
}

export type FormField = {
  key: string;
  label?: string | ((field: FormField) => any);
  type?: 'text' | 'textarea' | 'email' | 'password' | 'checkbox' | 'radio' | 'select' | 'number' | 'info' | 'header' | 'geo-point' | 'geo-polygon' | 'tel' | 'tabGroup' | 'switch' | 'autosuggest'  | 'autocomplete' | 'file' | 'link' | 'color' | 'date-time' | 'time-range' | 'date' | 'date-range-picker' | 'custom-date' | 'custom-time' | 'time' | 'dynamicSearch';
  icon?: string;
  layout?: 'block' | 'direction-col' | undefined;
  placeholder?: string;
  values?: any[] | ((...args: any) => void);
  defaultValue?: any;
  validations?: FormFieldValidations | undefined;
  disabled?: boolean | ((...arg: any) => boolean);
  formatOptionLabel?: (data: any) => any;
  renderInput?: (arg: any) => void;
  renderField?: (arg: any) => void;
  getValue?: (arg: any) => void;
  min?: number | string;
  max?: number;
  minTime?: Date,
  minDate?: Date;
  step?: number;
  prepend?: string;
  prependIcon?: string;
  append?: string;
  appendIcon?: string;
  iconSize?: 'sm' | 'lg';
  defaultChecked?: boolean;
  isMulti?: boolean;
  isValid?: boolean;
  invalid?: boolean;
  defaultOptions?: any;
  onChange?: (...args: any) => void;
  onBlur?: (...args: any) => void;
  onInputChange?: (...args: any) => void;
  dateInputEvents?: dateInputEvents;
  link?: string;
  fileUploadOptions?: FileOploadOptions;
  selectOptions?: SelectOptions;
  dateInputOptions?: DateInputOptions;
  emptyText?: string,
  displaySize?: string,
  orientation?: string;
  dateTimeText?: string;
  rows?: number;
  className?: string;
  fieldKey?: string | number;
  ref?: any;
  columnSize?: number;
  infoText?: string;
  deleteIcon?: string;
  onDelete?: (...args: any) => void;
  customStyles?: any;
  isMobileViewEnabled?: boolean;
  loading?: boolean;
  menuPlacement?: string;
  innerComponentProps?: object;
}

export type FormFieldValidations = {
  [key: string]: any;
}
